<template>
  <div>
    <div class="font-weight-bold text-uppercase text-center table-outer-title">
      Controle de Limites
    </div>
    <div class="table-container">
      <table>
        <tr>
          <th style="width: 50%">Valor Total do Projeto no Ano-Base</th>
          <td style="width: 50%">{{ limites.valor_total_projeto | toCurrency }}</td>
        </tr>
        <tr>
          <th>Total Gasto</th>
          <td>
            {{ limites.total_gasto | toCurrency }}
            ({{ limites.percentual_utilizado }}%)
          </td>
        </tr>
        <tr>
          <th>
            Custo Incorrido (máx. 20%)
          </th>
          <td>
            {{ limites.custo_incorrido_atual | toCurrency }}
            de {{ limites.custo_incorrido_limite | toCurrency }}
            ({{ limites.custo_incorrido_percentual }}%)
            <v-icon
              small
              :color="corIconeStatus"
              class="ml-1"
              v-text="nomeIconeStatus"
            ></v-icon>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "ControleLimites",
  props: {
    limites: {
      type: Object,
      required: true,
    },
  },
  computed: {
    iconeStatusOk() {
      return this.limites.custo_incorrido_percentual <= 20;
    },
    nomeIconeStatus() {
      return this.iconeStatusOk ? "mdi-check-circle" : "mdi-alert-circle";
    },
    corIconeStatus() {
      return this.iconeStatusOk ? "green" : "red";
    },
  },
};
</script>

<style lang="scss" scoped src="../styles/report.scss"></style>